import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import BackButtonComponent, { BackButtonProps } from 'components/BackButton';

const BackButton: FC<BackButtonProps> = (props) => (
  <Box paddingBottom="space-24">
    <BackButtonComponent {...props} />
  </Box>
);

export default BackButton;
